module.exports = __webpack_public_path__ + "static/media/0321_IMG_LES_ENSEIGNES_LES_PAINS_SCRABBLE.121e305e.png";